import Vue from 'vue'
import VueRouter from 'vue-router'

const originalPush = VueRouter.prototype.push
VueRouter.prototype.push = function push(location) {
  return originalPush.call(this, location).catch(err => err)
}

const originalReplace = VueRouter.prototype.replace;
VueRouter.prototype.replace = function replace(location) {
  return originalReplace.call(this, location).catch(err => err);
};
Vue.use(VueRouter)

const routes = [
  {
    path: '/',
    component: (reslove) => require(['@/views/NavBottom.vue'], reslove),
    children: [
      {
        path: '/',
        redirect: '/terminal',
      },
      {
        /**
         * 首页
         */
        path: '/index',
        name: 'Index',
        meta: {
          title: 'home'
        },
        component: (reslove) => require(['@/views/Index.vue'], reslove),
      },
      {
        /**
         * 终端信息
         */
        path: '/terminal',
        name: 'terminal',
        meta: {
          title: 'terminal'
        },
        component: (reslove) => require(['@/views/Terminal.vue'], reslove),
      }, {
        /**
         * 终端
         */
        path: '/information',
        name: 'information',
        meta: {
          title: 'terminal_info'
        },
        component: (resolve) => require(['@/views/Tinformation.vue'], resolve),
      },
       {
        /**
         * 节目
         */
        path: '/program',
        name: 'Program',
        meta: {
          title: 'program'
        },
        component: (reslove) => require(['@/views/Programs.vue'], reslove),
      }, {
        /**
         * 我的
         */
        path: '/my',
        name: 'My',
        meta: {
          title: 'my'
        },
        component: (reslove) => require(['@/views/My.vue'], reslove),
      }, {
        /**
         *遥控
         */
        path: '/telecontrol',
        name: 'telecontrol',
        meta: {
          title: 'remote_control'
        },
        component: (reslove) => require(['@/components/telecontrol.vue'], reslove),
      },
      {
        /**
         * 扫码连接
         */
        path: '/scanConnect',
        name: '扫码连接',
        meta: {
          title: 'scanConnect'
        },
        component: (resolve) => require(['@/components/scanConnect.vue'], resolve),
      },

      {
        /**
         * 审核管理
         */
        path: '/audit',
        name: 'audit',
        meta: {
          title: 'audit'
        },
        component: (resolve) => require(['@/components/audit.vue'], resolve),
      },
      {
        /**
         * 资料下载
         */
        path: '/myExplain',
        name: 'myExplain',
        meta: {
          title: 'myExplain'
        },
        component: (resolve) => require(['@/views/myExplain.vue'], resolve),
      },
      {
        /**
         * 客户查询编辑
         */
        path: '/customers',
        name: 'customers',
        meta: {
          title: 'customers'
        },
        component: (resolve) => require(['@/views/customers.vue'], resolve),
      },


      {
        /*
        * 绑定任务 taskInfo
        * */
        path: '/taskInfo',
        name: 'taskInfo',
        meta: {
          title: 'taskInfo'
        },
        component: (reslove) => require(['@/views/taskInfo.vue'], reslove),
      },
      {
        /*
        * 定时开关机 scheduleOnOff.vue
        * */
        path: '/scheduleOnOff',
        name: 'scheduleOnOff',
        meta: {
          title: 'taskInfo'
        },
        component: (reslove) => require(['@/views/scheduleOnOff.vue'], reslove),
      },
      {
        /**
         * 素材管理
         */
        path: '/scanCodePage',
        name: '扫码连接',
        meta: {
          title: 'scanCodePage'
        },
        component: (resolve) => require(['@/views/scanCodePage.vue'], resolve),
      },
    ],
  },
  {
    /**
     * 创建节目
     */
    path: '/createProrram',
    name: 'createProrram',
    meta: {
      title: 'create_program'
    },
    component: (resolve) => require(['@/views/createProrram.vue'], resolve),
  },

  {
    path: '/material',
    name: 'material',
    meta: {
      title: 'material_management'
    },
    component: (resolve) => require(['@/components/material.vue'], resolve),
  },

  {
    /**
     * 登录
     */
    path: '/login',
    name: 'Login',
    meta: {
      title: 'login'
    },
    component: (resolve) => require(['@/views/Login.vue'], resolve),
  },
  {
    path: '/resetPwd',
    name: 'resetPwd',
    meta: {
      title: 'reset_password'
    },
    component: (resolve) => require(['@/views/resetPwd.vue'], resolve),
  },
  {
    /**
     * 注册
     */
    path: '/Register',
    name: 'Register',
    meta: {
      title: 'login'
    },
    component: (resolve) => require(['@/views/Register.vue'], resolve),
  },
      {
    /**
     * 注册
     */
    path: '/Help',
    name: 'Help',
    meta: {
      title: 'Help'
    },
    component: (resolve) => require(['@/views/Help.vue'], resolve),
  },
  {
    path: '/editPass',
    name: 'editPass',
    meta: {
      title: 'change_password'
    },
    component: (resolve) => require(['@/views/editPass.vue'], resolve),
  },

  {
    /**
     * 预览
     */
    path: '/preview',
    name: 'preview',
    meta: {
      title: 'preview'
    },
    component: (resolve) => require(['@/views/preview.vue'], resolve),
  },
  {
    /**
     * 预览
     */
    path: '/sr',
    name: '终端扫码跳转更多页面',
    meta: {
      title: 'ScanRedirectPage'
    },
    component: (resolve) => require(['@/views/ScanRedirectPage.vue'], resolve),
  },
  {
    /**
     * 登录
     */
    path: '/h5Preview/:id',
    name: 'h5Preview',
    meta: {
      title: 'login'
    },
    component: (resolve) => require(['@/views/h5Preview.vue'], resolve),
  },
  {
    /**
     * 预览
     */
    path: '/h5editer/:id',
    name: 'h5editer',
    meta: {
      title: 'preview'
    },
    component: (resolve) => require(['@/views/h5editer.vue'], resolve),
  },
  {
    /*
    * 设备列表管理
    * */
    path: '/deviceListManagement',
    name:'deviceListManagement',
    meta:{
      title:'deviceListManagement',

    },
    component:(resolve) =>require(['@/views/deviceListManagement.vue'],resolve)
  },
  {
    /**
     * 任务详情
     */
    path: '/taskdetail',
    name: 'taskdetail',
    meta: {
      title: 'task_details'
    },
    component: (reslove) => require(['@/components/taskdetail.vue'], reslove),
  }, {
    /**
     * 添加任务
     */
    path: '/addTask',
    name: 'addTask',
    meta: {
      title: 'add_task'
    },
    component: (reslove) => require(['@/components/addTask.vue'], reslove),
  }, {
    /**
     * 节目列表
     */
    path: '/programItem',
    name: 'programItem',
    meta: {
      title: 'program_list'
    },
    component: (resolve) => require(['@/views/programItem.vue'], resolve),
  }, {
    /**
     * 增加分辨率
     */
    path: '/addresolution',
    name: 'addresolution',
    meta: {
      title: 'add_resolution'
    },
    component: (resolve) => require(['@/views/addresolution.vue'], resolve),
  }, {
    /**
     * 增加节目
     */
    path: '/newprogram',
    name: 'newprogram',
    meta: {
      title: 'add_program'
    },
    component: (resolve) => require(['@/views/newprogram.vue'], resolve),
  },
  {
    /**
     * 创建节目
     */
    path: '/h5Prorram',
    name: 'h5Prorram',
    meta: {
      title: 'h5program'
    },
    component: (resolve) => require(['@/views/h5Prorram.vue'], resolve),
    children: [
      {// 重定向，默认显示重定向的路由
        path: "/h5Prorram",
        redirect: "/h5Prorram/production"
      },
      {
        path: "/h5Prorram/template",
        name: "template",
        component: (resolve) => require(["@/views/template.vue"], resolve)
      },
      {
        path: "/h5Prorram/production",
        name: "production",
        component: (resolve) => require(["@/views/production.vue"], resolve)
      },

    ]
  },
]

const router = new VueRouter({
  mode: 'hash',
  base: process.env.BASE_URL,
  routes,
})

export default router
